import React from 'react';
import MainMenu_ChatsAdd from "./add-chat";

type Props = {

}


export default function MainMenu_ChatsNotFound(props: Props) {

    return (
        <div>
            <div className="ui5-txt-not-important m-l-30 m-b-10 m-t-10">
                No Chats found
            </div>

            <MainMenu_ChatsAdd />
        </div>
    );
}